module.exports = __webpack_public_path__ + "img/babybook-sparkle.8b236d5b.svg";